import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/trpc/trpc";
import { Building2, Users, ShoppingCart } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/")({
  component: AdminDashboard,
});

function StatCard({
  title,
  value,
  icon: Icon,
}: {
  title: string;
  value: number;
  icon: React.ElementType;
}) {
  return (
    <div className="rounded-lg border bg-card p-6">
      <div className="flex items-center gap-3">
        <div className="flex size-10 items-center justify-center rounded-md bg-primary/10">
          <Icon className="size-5 text-primary" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className="text-2xl font-bold">{value}</p>
        </div>
      </div>
    </div>
  );
}

function AdminDashboard() {
  const { data: stats, isLoading } = trpc.admin.dashboardStats.useQuery();

  if (isLoading) {
    return <div className="text-muted-foreground">Ładowanie...</div>;
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Dashboard</h1>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard
          title="Salony"
          value={stats?.salons ?? 0}
          icon={Building2}
        />
        <StatCard
          title="Użytkownicy"
          value={stats?.users ?? 0}
          icon={Users}
        />
        <StatCard
          title="Zakupy"
          value={stats?.purchases ?? 0}
          icon={ShoppingCart}
        />
      </div>
    </div>
  );
}
